module.exports = __webpack_public_path__ + "static/media/Other.73713b64.svg";